/* eslint-disable */
const PAD0 = 0xec;
const PAD1 = 0x11;
const EC_LEVEL_M = 0;
const RS_BLOCK_TABLE = {
  1: [[1, 26, 16]],
  2: [[1, 44, 28]],
  3: [[1, 70, 44]],
  4: [[2, 50, 32]],
  5: [[2, 67, 43]],
  6: [[4, 43, 27]],
  7: [[4, 49, 31]],
  8: [
    [2, 60, 38],
    [2, 61, 39],
  ],
  9: [
    [3, 58, 36],
    [2, 59, 37],
  ],
  10: [
    [4, 69, 43],
    [1, 70, 44],
  ],
};
const ALIGNMENT_PATTERN_TABLE = {
  1: [],
  2: [6, 18],
  3: [6, 22],
  4: [6, 26],
  5: [6, 30],
  6: [6, 34],
  7: [6, 22, 38],
  8: [6, 24, 42],
  9: [6, 26, 46],
  10: [6, 28, 50],
};

let EXP_TABLE = [];
let LOG_TABLE = [];
for (let i = 0; i < 8; i++) {
  EXP_TABLE[i] = 1 << i;
}
for (let i = 8; i < 256; i++) {
  EXP_TABLE[i] =
    EXP_TABLE[i - 4] ^ EXP_TABLE[i - 5] ^ EXP_TABLE[i - 6] ^ EXP_TABLE[i - 8];
}
for (let i = 0; i < 255; i++) {
  LOG_TABLE[EXP_TABLE[i]] = i;
}

const gexp = (n) => {
  while (n < 0) n += 255;
  while (n >= 256) n -= 255;
  return EXP_TABLE[n];
};

const glog = (n) => {
  if (n < 1) throw new Error("glog");
  return LOG_TABLE[n];
};

const gfMul = (a, b) => {
  if (a === 0 || b === 0) return 0;
  return gexp(glog(a) + glog(b));
};

const getBytes = (text) => {
  if (window.TextEncoder) {
    return Array.from(new TextEncoder().encode(text));
  }
  const encoded = unescape(encodeURIComponent(text));
  const bytes = [];
  for (let i = 0; i < encoded.length; i++) {
    bytes.push(encoded.charCodeAt(i));
  }
  return bytes;
};

const getBlocks = (version) => {
  const rows = RS_BLOCK_TABLE[version];
  const blocks = [];
  rows.forEach((row) => {
    for (let i = 0; i < row[0]; i++) {
      blocks.push({
        totalCount: row[1],
        dataCount: row[2],
      });
    }
  });
  return blocks;
};

const getDataCapacity = (version) => {
  return getBlocks(version).reduce((sum, block) => sum + block.dataCount, 0);
};

const chooseVersion = (bytesLength) => {
  for (let version = 1; version <= 10; version++) {
    const charCountBits = version < 10 ? 8 : 16;
    const capacityBits = getDataCapacity(version) * 8;
    if (4 + charCountBits + bytesLength * 8 <= capacityBits) {
      return version;
    }
  }
  throw new Error("二维码内容过长，暂不支持渲染");
};

const pushBits = (buffer, value, length) => {
  for (let i = length - 1; i >= 0; i--) {
    buffer.push(((value >>> i) & 1) === 1);
  }
};

const createGeneratorPoly = (degree) => {
  let poly = [1];
  for (let i = 0; i < degree; i++) {
    const next = new Array(poly.length + 1).fill(0);
    for (let j = 0; j < poly.length; j++) {
      next[j] ^= poly[j];
      next[j + 1] ^= gfMul(poly[j], gexp(i));
    }
    poly = next;
  }
  return poly;
};

const createErrorCorrection = (data, ecCount) => {
  const generator = createGeneratorPoly(ecCount);
  const message = data.concat(new Array(ecCount).fill(0));
  for (let i = 0; i < data.length; i++) {
    const coefficient = message[i];
    if (coefficient === 0) continue;
    for (let j = 0; j < generator.length; j++) {
      message[i + j] ^= gfMul(generator[j], coefficient);
    }
  }
  return message.slice(message.length - ecCount);
};

const createDataCodewords = (bytes, version) => {
  const totalDataCount = getDataCapacity(version);
  const bits = [];
  pushBits(bits, 4, 4);
  pushBits(bits, bytes.length, version < 10 ? 8 : 16);
  bytes.forEach((byte) => pushBits(bits, byte, 8));

  const capacityBits = totalDataCount * 8;
  const terminator = Math.min(4, capacityBits - bits.length);
  pushBits(bits, 0, terminator);
  while (bits.length % 8 !== 0) bits.push(false);

  const data = [];
  for (let i = 0; i < bits.length; i += 8) {
    let codeword = 0;
    for (let j = 0; j < 8; j++) {
      codeword = (codeword << 1) | (bits[i + j] ? 1 : 0);
    }
    data.push(codeword);
  }
  while (data.length < totalDataCount) {
    data.push(data.length % 2 === 0 ? PAD0 : PAD1);
  }
  return data;
};

const createCodewords = (bytes, version) => {
  const blocks = getBlocks(version);
  const dataCodewords = createDataCodewords(bytes, version);
  const dcData = [];
  const ecData = [];
  let offset = 0;
  let maxDcCount = 0;
  let maxEcCount = 0;

  blocks.forEach((block) => {
    const dc = dataCodewords.slice(offset, offset + block.dataCount);
    const ecCount = block.totalCount - block.dataCount;
    dcData.push(dc);
    ecData.push(createErrorCorrection(dc, ecCount));
    offset += block.dataCount;
    maxDcCount = Math.max(maxDcCount, dc.length);
    maxEcCount = Math.max(maxEcCount, ecCount);
  });

  const data = [];
  for (let i = 0; i < maxDcCount; i++) {
    for (let r = 0; r < dcData.length; r++) {
      if (i < dcData[r].length) data.push(dcData[r][i]);
    }
  }
  for (let i = 0; i < maxEcCount; i++) {
    for (let r = 0; r < ecData.length; r++) {
      if (i < ecData[r].length) data.push(ecData[r][i]);
    }
  }
  return data;
};

const createMatrix = (version) => {
  const count = version * 4 + 17;
  const modules = Array.from({ length: count }, () =>
    new Array(count).fill(false)
  );
  const reserved = Array.from({ length: count }, () =>
    new Array(count).fill(false)
  );

  const setModule = (row, col, dark, isReserved = true) => {
    if (row < 0 || col < 0 || row >= count || col >= count) return;
    modules[row][col] = !!dark;
    if (isReserved) reserved[row][col] = true;
  };

  const setupPositionProbe = (row, col) => {
    for (let r = -1; r <= 7; r++) {
      for (let c = -1; c <= 7; c++) {
        const rr = row + r;
        const cc = col + c;
        if (rr < 0 || cc < 0 || rr >= count || cc >= count) continue;
        const dark =
          (r >= 0 && r <= 6 && (c === 0 || c === 6)) ||
          (c >= 0 && c <= 6 && (r === 0 || r === 6)) ||
          (r >= 2 && r <= 4 && c >= 2 && c <= 4);
        setModule(rr, cc, dark);
      }
    }
  };

  const setupAlignment = (row, col) => {
    for (let r = -2; r <= 2; r++) {
      for (let c = -2; c <= 2; c++) {
        setModule(row + r, col + c, Math.max(Math.abs(r), Math.abs(c)) !== 1);
      }
    }
  };

  setupPositionProbe(0, 0);
  setupPositionProbe(count - 7, 0);
  setupPositionProbe(0, count - 7);

  for (let r = 8; r < count - 8; r++) {
    setModule(r, 6, r % 2 === 0);
    setModule(6, r, r % 2 === 0);
  }

  const positions = ALIGNMENT_PATTERN_TABLE[version];
  positions.forEach((row) => {
    positions.forEach((col) => {
      if (reserved[row][col]) return;
      setupAlignment(row, col);
    });
  });

  setModule(count - 8, 8, true);

  return { modules, reserved, count, setModule };
};

const getBchDigit = (data) => {
  let digit = 0;
  while (data !== 0) {
    digit++;
    data >>>= 1;
  }
  return digit;
};

const getBchTypeInfo = (data) => {
  let d = data << 10;
  const g = 0x537;
  while (getBchDigit(d) - getBchDigit(g) >= 0) {
    d ^= g << (getBchDigit(d) - getBchDigit(g));
  }
  return ((data << 10) | d) ^ 0x5412;
};

const getBchVersion = (data) => {
  let d = data << 12;
  const g = 0x1f25;
  while (getBchDigit(d) - getBchDigit(g) >= 0) {
    d ^= g << (getBchDigit(d) - getBchDigit(g));
  }
  return (data << 12) | d;
};

const setupTypeInfo = (matrix, maskPattern) => {
  const bits = getBchTypeInfo((EC_LEVEL_M << 3) | maskPattern);
  const { count, setModule } = matrix;
  for (let i = 0; i < 15; i++) {
    const mod = ((bits >> i) & 1) === 1;
    if (i < 6) setModule(i, 8, mod);
    else if (i < 8) setModule(i + 1, 8, mod);
    else setModule(count - 15 + i, 8, mod);

    if (i < 8) setModule(8, count - i - 1, mod);
    else if (i < 9) setModule(8, 15 - i, mod);
    else setModule(8, 14 - i, mod);
  }
};

const setupVersionInfo = (matrix, version) => {
  if (version < 7) return;
  const bits = getBchVersion(version);
  const { count, setModule } = matrix;
  for (let i = 0; i < 18; i++) {
    const mod = ((bits >> i) & 1) === 1;
    setModule(Math.floor(i / 3), (i % 3) + count - 11, mod);
    setModule((i % 3) + count - 11, Math.floor(i / 3), mod);
  }
};

const mask = (row, col) => {
  return (row + col) % 2 === 0;
};

const mapData = (matrix, data) => {
  const { modules, reserved, count } = matrix;
  let inc = -1;
  let row = count - 1;
  let bitIndex = 7;
  let byteIndex = 0;

  for (let col = count - 1; col > 0; col -= 2) {
    if (col === 6) col--;
    while (true) {
      for (let c = 0; c < 2; c++) {
        const cc = col - c;
        if (!reserved[row][cc]) {
          let dark = false;
          if (byteIndex < data.length) {
            dark = ((data[byteIndex] >>> bitIndex) & 1) === 1;
          }
          if (mask(row, cc)) dark = !dark;
          modules[row][cc] = dark;
          reserved[row][cc] = true;
          bitIndex--;
          if (bitIndex === -1) {
            byteIndex++;
            bitIndex = 7;
          }
        }
      }
      row += inc;
      if (row < 0 || row >= count) {
        row -= inc;
        inc = -inc;
        break;
      }
    }
  }
};

export const createQrMatrix = (text) => {
  const bytes = getBytes(text);
  const version = chooseVersion(bytes.length);
  const matrix = createMatrix(version);
  setupTypeInfo(matrix, 0);
  setupVersionInfo(matrix, version);
  mapData(matrix, createCodewords(bytes, version));
  return matrix.modules;
};

export const drawQrCode = (canvas, text, size = 220) => {
  const modules = createQrMatrix(text);
  const count = modules.length;
  const margin = 4;
  const cell = Math.floor(size / (count + margin * 2));
  const realSize = cell * (count + margin * 2);
  const ctx = canvas.getContext("2d");
  canvas.width = realSize;
  canvas.height = realSize;
  ctx.fillStyle = "#ffffff";
  ctx.fillRect(0, 0, realSize, realSize);
  ctx.fillStyle = "#111111";
  for (let row = 0; row < count; row++) {
    for (let col = 0; col < count; col++) {
      if (modules[row][col]) {
        ctx.fillRect((col + margin) * cell, (row + margin) * cell, cell, cell);
      }
    }
  }
};
